const REQUIRED_LENGTH_FOR_KEYWORD = 4;
const REQUIRED_LENGTH_FOR_PHONE_NUMBER = 6;

export const validateTypeAheadKeyword = keyword => {
  const trimmedKeyword = keyword.trim();
  const includesLetters = trimmedKeyword.match(/[a-zA-Z]/);

  if (includesLetters) {
    return trimmedKeyword.length >= REQUIRED_LENGTH_FOR_KEYWORD;
  }

  if (trimmedKeyword.startsWith('+')) {
    return trimmedKeyword.length >= REQUIRED_LENGTH_FOR_PHONE_NUMBER + 2;
  }

  return trimmedKeyword.length >= REQUIRED_LENGTH_FOR_PHONE_NUMBER;
};

export const changeTypeAheadParams = ({ value, typeAheadParams }) => {
  const includesLetters = value.match(/[a-zA-Z]/);
  return !includesLetters
    ? {
        ...typeAheadParams,
        keyword: undefined,
        partialPhone: value
      }
    : typeAheadParams;
};
